import { render, staticRenderFns } from "./fccHistorico.vue?vue&type=template&id=ec058cd4"
import script from "./fccHistorico.vue?vue&type=script&lang=js"
export * from "./fccHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports